<template>
    <div>
        <v-app-bar class="app-top-navbar" color="primary" dark flat>
           <v-container>
               <v-row align="center">
                   <v-col>
                       <router-link to="/" class="logo"> <span class="main">CheckOn</span> <span class="sub">Admin</span>  </router-link>
                   </v-col>
                   <v-col class="text-right">
                       <v-btn normal class="log-out-button" @click="logout">
                           <v-icon>exit_to_app</v-icon>
                           <span class="exit-text">Kilépés </span>
                       </v-btn>
                   </v-col>
               </v-row>
           </v-container>
        </v-app-bar>
        <v-content>
            <slot />
        </v-content>
    </div>

</template>

<script>
    export default {
        name: "Default",

        methods: {
            logout: function() {
                this.$store.dispatch("auth/logout").then(() => {
                    this.$router.push("/login");
                });
            }
        }
    }
</script>

<style lang="scss">
    @import "../scss/global";
    .app-top-navbar {
        .logo {
            color: #efefef; text-decoration: none; text-transform: uppercase; font-size: 23px;
            span.main { font-weight: 800; }
        }

        .log-out-button {
            background: #efefef!important; color: #2c3e50!important;
        }
    }

    @media only screen and (max-width: 450px) {
        .app-top-navbar .logo {
            font-size: 20px;
            padding-top: 5px;
        }
    }

    @media only screen and (max-width: 385px) {
        .app-top-navbar .logo {
            span.sub { display: none; }
        }
        .exit-text {
            display: none;
        }
    }




</style>
